<template>
  <div class="addGroup">
    <header class="modal-header">
        <span class="entity-title" v-if="action=='add'">{{ $t('group.addGroup') }} </span>
        <span class="entity-title" v-if="action=='edit'">{{ $t('group.editGroup') }} ({{$t('tournaments.group')}})</span>
    </header>
    <div class="content"> 
      <div class="details">
        <label>
          {{ $t('tournaments.name') }}
          <input v-model="group.name" class="theme-input" type="text" placeholder="naam">
        </label>
        <div class="buttons">
          <button class="button-default" @click="addAndNew">{{ $t('app.actions.addAndNew') }}</button>
        </div>
        <div class="buttons">
          <div v-if="action=='edit'">
            <button class="button-default" @click="edit">{{ $t('app.actions.edit') }}</button>
          </div>
          <div v-if="action=='add'">
            <button class="button-default" @click="add">{{ $t('app.actions.add') }}</button>
          </div>
          <button class="button-default" @click="cancel">{{ $t('app.actions.cancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';

export default {
  name: 'AddGroup',
  components: {},
  props: {
    tournamentId: String,
    groupdId: String,
    action: String
  },
  data: function () {
    return {
      group: {tournamentId: this.$route.params.tournamentId, number: -1},
      afterAddAndNew: false
    }
  },
  emits: [ 'cancel', 'ok' ],
  beforeMount() {
    if (this.action == "edit") {
      this.loadGroup();
    }
  },
  methods: {
    add: function () {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.group,
        response: false, 
      };
      let path = '/group/';
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
            that.group = response;
            console.log("Group saved: "+ that.group.groupId);
            that.$emit('ok');
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    addAndNew: function () {
      let that = this;
      this.afterAddAndNew = true;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.group,
        response: false, 
      };
      let path = '/group/';
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
            that.group = response;
            console.log("Group saved: "+ that.group.groupId);
            // Do not emit, but reset for a new round.
            that.group = {tournamentId: that.$route.params.tournamentId, number: -1};
            console.log("Group reset. ");
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    cancel: function() {
      if (this.afterAddAndNew)
        this.$emit('ok');
      else
        this.$emit('cancel');
    },

    edit: function () {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.group,
        response: false, 
      };
      let path = "/group/" + this.groupId;
      RestAPI
        .put(apiName, path, myInit)
        .then(response => {
            console.log("Group edited: " + response);
            that.$emit('ok');
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadGroup: function () {
      let that = this;
      const myInit = { 
        response: false, 
      };
      let path = '/group/' + this.groupId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
            that.group = response;
            console.log("Group loaded: "+ that.group.groupId);
        })
        .catch(error => {
          console.log(error.response);
        });
    }
  }
}

</script>

<style scoped>

.container {
  width: 100vw;
  display: flex;
  justify-content: center;
}

</style>
